import { useState } from 'react';
import './WaterSystemSummaryTable.css';
import { formatDate } from '../../utilities/commonFunctions/formattingFunctions';


const WaterSystemSummaryTable = ({selectedWaterSystem}) => {
  const [expanded, setExpanded] = useState(true);

  const waterSystemInfo = {
    activityStatus: selectedWaterSystem.activityStatus,
    alternateNum: selectedWaterSystem.alternateNum,
    email: selectedWaterSystem.adminContact?.email,
    email2: selectedWaterSystem.adminContact?.email2,
    email3: selectedWaterSystem.adminContact?.email3,
    adminFirstName: selectedWaterSystem.adminContact?.adminFirstName,
    adminLastName: selectedWaterSystem.adminContact?.adminLastName,
    adminPhone: selectedWaterSystem.adminContact?.adminPhone,
    adminPhoneExt: selectedWaterSystem.adminContact?.adminPhoneExt,
    adminEmergencyPhone: selectedWaterSystem.adminContact?.adminEmergencyPhone,
    adminEmergencyPhoneExt: selectedWaterSystem.adminContact?.adminEmergencyPhoneExt,
    county: selectedWaterSystem.county,
    countyServed: selectedWaterSystem.countyServed,
    districtNumber: selectedWaterSystem.districtNumber,
    ipsLastUpdateTs: formatDate(selectedWaterSystem?.rating?.ipsLastUpdateTs, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }),
    indicatorName: selectedWaterSystem.indicatorName,
    lastInventoryUpdateDate: formatDate(selectedWaterSystem.lastInventoryUpdateDate, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }),
    lastUpdateDate: formatDate(selectedWaterSystem.lastUpdateDate, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }),
    certLevel: selectedWaterSystem.legalContact?.certLevel,
    certType: selectedWaterSystem.legalContact?.certType,
    lcAddress1: selectedWaterSystem.legalContact?.lcAddress1,
    lcAddress2: selectedWaterSystem.legalContact?.lcAddress2,
    lcCity: selectedWaterSystem.legalContact?.lcCity,
    lcFirstName: selectedWaterSystem.legalContact?.lcFirstName,
    lcState: selectedWaterSystem.legalContact?.lcState,
    lcZip: selectedWaterSystem.legalContact?.lcZip,
    lhdName: selectedWaterSystem.legalContact?.lhdName,
    operatorEndDay: selectedWaterSystem.operatingPeriod?.operatorEndDay,
    operatorEndMonth: selectedWaterSystem.operatingPeriod?.operatorEndMonth,
    operatorStartDay: selectedWaterSystem.operatingPeriod?.operatorStartDay,
    operatorStartMonth: selectedWaterSystem.operatingPeriod?.operatorStartMonth,
    phone: selectedWaterSystem.legalContact?.phone,
    population: selectedWaterSystem.population,
    rating: selectedWaterSystem.rating?.rating,
    ratingDate: formatDate(selectedWaterSystem.rating?.ratingDate, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }),
    surveyDate: formatDate(selectedWaterSystem.lastSurvey?.surveyDate, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }),
    surveyorFirstName: selectedWaterSystem.lastSurvey?.surveyorFirstName,
    surveyorLastName: selectedWaterSystem.lastSurvey?.surveyorLastName,
    systemId: selectedWaterSystem.systemId,
    systemName: selectedWaterSystem.systemName,
    pwsId: selectedWaterSystem.pwsId,
    systemType: selectedWaterSystem.systemType,
    totalIpsPoints: selectedWaterSystem?.rating?.totalIpsPoints,
    waterUsageAvgAnnualDemand: selectedWaterSystem.waterUsage?.avgAnnualDemand.toFixed(1),
    waterUsagecreatedDate: formatDate(selectedWaterSystem.waterUsage?.createdTs, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }),
    waterUsageEqualizationStorage: selectedWaterSystem.waterUsage?.equalizationStorage.toFixed(1),
    waterUsagePeakDayDemand: selectedWaterSystem.waterUsage?.peakDayDemand.toFixed(1),
    zone: selectedWaterSystem.zone?.zone,
    zoneDate: selectedWaterSystem.zone?.zoneDate,
    requiredToDisinfectDate: selectedWaterSystem.requiredToDisinfectDate? formatDate(selectedWaterSystem.requiredToDisinfectDate, { hour: undefined, minute: undefined, second: undefined, hour12: undefined }) : null,
  };

  let ratingClass;
  switch (waterSystemInfo.rating) {
    case 'Approved':
      ratingClass = 'rating-approved';
      break;
    case 'Corrective Action':
      ratingClass = 'rating-correction';
      break;
    case 'Not Approved':
      ratingClass = 'rating-not-approved';
      break;
    default:
      ratingClass = 'rating-none';
      break;
  }

  const showWaterUsage = waterSystemInfo.waterUsageAvgAnnualDemand || waterSystemInfo.waterUsagePeakDayDemand || waterSystemInfo.waterUsageEqualizationStorage;
  return (
    <div className="water-system-summary-table">
      <div className="water-system-summary-header">
        <div className="water-system-name">
          <ul>
            <li className="system-name">Water System: {waterSystemInfo.systemName}</li>
            <li className="pws-id">PWS ID: {waterSystemInfo.pwsId}</li>
          </ul>
        </div>
        <div className={`water-system-rating ${ratingClass}`}>
          <ul>
            <li className="rating">Rating: {waterSystemInfo.rating}</li>
            <li>{waterSystemInfo.ratingDate}</li>
            <li className="status">Status: {waterSystemInfo.activityStatus}</li>
          </ul>
        </div>
        <button 
          className={`collapse-icon-btn ${ratingClass}`}
          onClick={() => setExpanded((prev) => !prev)}
          aria-label={expanded ? 'Collapse summary details' : 'Expand summary details'}
          aria-expanded={expanded}
          aria-controls="water-system-info-wrapper"
        >
          {expanded ? (
            <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '2rem', width: '2rem' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" focusable="false">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" style={{ height: '2rem', width: '2rem' }} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" focusable="false">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </button>
      </div>
      <div className="clearfix"></div>
      <div
        className={`water-system-info-wrapper${expanded ? ' expanded' : ''}`}
        id="water-system-info-wrapper"
      >
        <div className="water-system-info">
          <div className="col4 col4-light contacts">
            <h2 className="water-system-summary-subheading">Contact Details</h2>
            <ul>
              <li><strong>Type:</strong> Admin Contact</li>
              <li><strong>Name:</strong> {waterSystemInfo.adminFirstName} {waterSystemInfo.adminLastName}</li>
              <li><strong>Office:</strong> {waterSystemInfo.adminPhone}</li>
              <li><strong>Emergency:</strong> {waterSystemInfo.adminEmergencyPhone}</li>
              <li><strong>Email:</strong> <br />{waterSystemInfo.email}<br />{waterSystemInfo.email2}<br />{waterSystemInfo.email3}</li>
            </ul>
          </div>
          <div className="col4 col4-dark site-info">
            <h2 className="water-system-summary-subheading">Site Information</h2>
            <ul>
              <li><strong>Legal Contact:</strong> {waterSystemInfo.lcFirstName}</li>
              <li>
                <strong>Address:</strong> {waterSystemInfo.lcAddress1} {waterSystemInfo.lcAddress2}<br></br>
                {waterSystemInfo.lcCity}, {waterSystemInfo.lcState} {waterSystemInfo.lcZip}
              </li>
              <li><strong>Phone:</strong> {waterSystemInfo.phone}</li>
              <li><strong>County:</strong> {waterSystemInfo.countyServed}</li>
              <li><strong>System Type:</strong> {waterSystemInfo.systemType}</li>
              <li><strong>Certification Required:</strong> {waterSystemInfo.certType}</li>
              <li><strong>Total Population:</strong> {waterSystemInfo.population}</li>
              <li><strong>Local Health District:</strong> {waterSystemInfo.lhdName}</li>
            </ul>
          </div>
          <div className="col4 col4-light site-updates">
            <h2 className="water-system-summary-subheading">Site Updates</h2>
            <ul>
              <li><strong>Last Inventory Update:</strong> {waterSystemInfo.lastInventoryUpdateDate}</li>
              <li><strong>Last Surveyor Update:</strong> {waterSystemInfo.surveyDate}</li>
              <li><strong>Surveyor:</strong> {waterSystemInfo.surveyorFirstName} {waterSystemInfo.surveyorLastName}</li>
              <li><strong>Operating Period:</strong> {waterSystemInfo.operatorStartMonth}/{waterSystemInfo.operatorStartDay} - {waterSystemInfo.operatorEndMonth}/{waterSystemInfo.operatorEndDay}</li>
              <li><strong>Last IPS Update:</strong> {waterSystemInfo.ipsLastUpdateTs}</li>
              {/* if waterSystemInfo.requiredToDisinfectDate is not null or undefined, then render a <li> for it */}
              {waterSystemInfo.requiredToDisinfectDate && (
                <li style={{ marginTop: '2rem' }}><strong>System is required to disinfect as of: {waterSystemInfo.requiredToDisinfectDate}</strong></li>
              )}
            </ul>
          </div>
          <div className="col4 col4-dark political-districts">
            <h2 className="water-system-summary-subheading">Political Districts</h2>
            <ul>
              <li><a href="https://le.utah.gov/GIS/findDistrict.jsp">Legislative District Map</a></li>
              <li style={{ marginTop: '0.5rem' }}><strong>Water Usage Information per ERC</strong></li>
              {showWaterUsage && (
                <>
                  <li>Standard as of: {waterSystemInfo.waterUsagecreatedDate}</li>
                  <li>Peak Day Demand per ERC (gal/ERC): {waterSystemInfo.waterUsagePeakDayDemand}</li>
                  <li>Average Annual Demand per ERC (gal/ERC): {waterSystemInfo.waterUsageAvgAnnualDemand}</li>
                  <li>Equalization Storage per ERC (gal/ERC): {waterSystemInfo.waterUsageEqualizationStorage}</li>
                </>
              )}
              <li>Total IPS Points: {waterSystemInfo.totalIpsPoints}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WaterSystemSummaryTable;